var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"dropdown-arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 0 24 24","width":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M7 10l5 5 5-5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }